import { css } from "@emotion/react";

export const productAddToCartWrapper = {
  base: css`
    display: flex;
    align-items: flex-end;

    > *:not(:last-child) {
      margin-right: 0.75rem;
    }
  `,
  large: css`
    margin-top: 1rem;
  `,
  medium: css`
    margin-top: 0.75rem;
  `,
  small: css`
    margin-top: 0.5rem;
  `,
};
